import React from "react";
import type {FunctionComponent} from "react";
import {WhenDevice} from "../../../../modules/conditional/when-device/WhenDevice";

export interface IWhenDeviceIOS {
  not?: boolean;
}

export const WhenDeviceIOS: FunctionComponent<IWhenDeviceIOS> = ({children, not}) => {

  if (!!not){
    // when not ios
    return <WhenDevice blockedOs={'ios'}>{children}</WhenDevice>;
  }

  return <WhenDevice allowedOs={'ios'}>{children}</WhenDevice>;
}
